import { render, staticRenderFns } from "./TablaSim.vue?vue&type=template&id=64786bdc&"
import script from "./TablaSim.vue?vue&type=script&lang=ts&"
export * from "./TablaSim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports